import { AlertTriangle, CheckCircle2, CircleOff, Link2, Link2Off } from 'lucide-react';
import type { ProductionLinkStatus } from '@quds/shared';
import { Badge } from '@/components/ui';
import { LINK_STATUS_TONES } from '@/features/production-linking/labels';

const ICONS: Record<ProductionLinkStatus, typeof Link2> = {
  Linked: CheckCircle2,
  'Partially Linked': Link2,
  'Not Linked': Link2Off,
  Conflict: AlertTriangle,
};

/** Compact production link status for pharmacy list and details. */
export function ProductionLinkBadge({ status, className }: { status: ProductionLinkStatus; className?: string }) {
  const Icon = status === 'Not Linked' ? Link2Off : ICONS[status];
  return (
    <Badge tone={LINK_STATUS_TONES[status]} title={`Production: ${status}`} icon={<Icon size={12} aria-hidden="true" />} className={className}>
      {status}
    </Badge>
  );
}

export function ProductionConnectionBadge({
  state,
  unavailable,
}: {
  state?: string;
  unavailable?: boolean;
}) {
  if (!state || state === 'disabled' || state === 'integration_disabled') {
    return (
      <Badge tone="neutral" icon={<CircleOff size={12} aria-hidden="true" />}>
        Production integration off
      </Badge>
    );
  }
  if (state === 'connected' && !unavailable) {
    return (
      <Badge tone="success" dot>
        Production connected
      </Badge>
    );
  }
  if (state === 'degraded') {
    return (
      <Badge tone="warning" dot>
        Production data stale
      </Badge>
    );
  }
  return (
    <Badge tone="warning" dot>
      Production unavailable
    </Badge>
  );
}
